/** Application entry point. */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { AuthProvider } from './lib/auth-context';
import { ConfigProvider } from './lib/config';
import { LiveProvider } from './lib/live';
import './styles/index.css';

const client = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 15_000,
    },
  },
});

const container = document.getElementById('root');
if (container === null) throw new Error('Missing #root');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <ConfigProvider>
        {/* One socket for the whole application: the board and the activity
            feed are two views of the same stream, and the address it opens
            comes from the configuration above it. */}
        <LiveProvider>
          <AuthProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </AuthProvider>
        </LiveProvider>
      </ConfigProvider>
    </QueryClientProvider>
  </StrictMode>,
);
